var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "cemetery-occupations-list" },
    _vm._l(_vm.items, function (item, idx) {
      return _c("CemeterySectorOccupationItem", {
        key: `cemetery-occupation-item-${idx}`,
        attrs: {
          value: item,
          cemeteryCode: _vm.cemeteryCode,
          panelCfg: _vm.panelCfg,
          baseTranslateID: _vm.baseTranslateID,
          enableView: _vm.allowView,
        },
        on: { view: _vm.onView },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }